import { unref } from "vue";
import { ChannelType } from "@/app/shared/utils/enums";

function getChannelId(item) {
  const e = unref(item); // acepta refs o valores planos

  if (Array.isArray(e?.items)) {
    return e.items[0]?.channel?.id;
  }
  if (Array.isArray(e)) {
    return e[0]?.channel?.id;
  }
  return e?.channel?.id;
}

function groupOrder(id) {
  return [ChannelType.Whatsapp, ChannelType.WhatsappVoice].includes(id)
    ? 0
    : 1;
}

export function sortIconChannels(list) {
  const arr = unref(list);                 // acepta ref/computed o array normal
  const safe = Array.isArray(arr) ? arr : []; // evita "list is not iterable"

  return [...safe].sort((a, b) => {
    const idA = getChannelId(a);
    const idB = getChannelId(b);

    const diffGroup = groupOrder(idA) - groupOrder(idB);
    if (diffGroup !== 0) return diffGroup;

    if (idA === undefined) return 1;
    if (idB === undefined) return -1;
    return idA - idB;
  });
}
